window.addEventListener('DOMContentLoaded', () => {

  $('.js-q-toggle').on('click', (e) => {
    const $question = $(e.target)
    const $answer = $question.next()

    $question.toggleClass('active')
    $answer.fadeToggle()
  })

  $('.js-step-1-btn').on('click', () => {
    $('.js-step-1-btn').toggleClass('active')
    $('.step-1').toggleClass('active')
    $('.step-1-d').toggleClass('active')
    //他セクションを閉じる
    $('.step-2-d').removeClass('active')
    $('.step-3-d').removeClass('active')
    $('.step-4-d').removeClass('active')
    $('.js-step-2-btn').removeClass('active')
    $('.js-step-3-btn').removeClass('active')
    $('.js-step-4-btn').removeClass('active')
    $('.step-2').removeClass('active')
    $('.step-3').removeClass('active')
    $('.step-4').removeClass('active')
  })

  $('.js-step-2-btn').on('click', () => {
    $('.js-step-2-btn').toggleClass('active')
    $('.step-2').toggleClass('active')
    $('.step-2-d').toggleClass('active')
    //他セクションを閉じる
    $('.step-1-d').removeClass('active')
    $('.step-3-d').removeClass('active')
    $('.step-4-d').removeClass('active')
    $('.js-step-1-btn').removeClass('active')
    $('.js-step-3-btn').removeClass('active')
    $('.js-step-4-btn').removeClass('active')
    $('.step-1').removeClass('active')
    $('.step-3').removeClass('active')
    $('.step-4').removeClass('active')
  })

  $('.js-step-3-btn').on('click', () => {
    $('.js-step-3-btn').toggleClass('active')
    $('.step-3').toggleClass('active')
    $('.step-3-d').toggleClass('active')
    //他セクションを閉じる
    $('.step-1-d').removeClass('active')
    $('.step-2-d').removeClass('active')
    $('.step-4-d').removeClass('active')
    $('.js-step-1-btn').removeClass('active')
    $('.js-step-2-btn').removeClass('active')
    $('.js-step-4-btn').removeClass('active')
    $('.step-1').removeClass('active')
    $('.step-2').removeClass('active')
    $('.step-4').removeClass('active')
  })

  $('.js-step-4-btn').on('click', () => {
    $('.js-step-4-btn').toggleClass('active')
    $('.step-4').toggleClass('active')
    $('.step-4-d').toggleClass('active')
    //他セクションを閉じる
    $('.step-1-d').removeClass('active')
    $('.step-2-d').removeClass('active')
    $('.step-3-d').removeClass('active')
    $('.js-step-1-btn').removeClass('active')
    $('.js-step-2-btn').removeClass('active')
    $('.js-step-3-btn').removeClass('active')
    $('.step-1').removeClass('active')
    $('.step-2').removeClass('active')
    $('.step-3').removeClass('active')
  })

  $('.icon-close').on('click', (e) => {
    $('.step-btn').removeClass('active')
    $('.step-item').removeClass('active')
    $('.step-detail').removeClass('active')
    const offset = $(e.target).parent('div').offset().top
    const stepitem = $('.step-item').outerHeight()
    const position = offset - stepitem - 60
    $(window).scrollTop(position)
  })
})
